export default "__VITE_ASSET__CPpMiVNR__"